import React from 'react';
import { TabButtons, TabHealthera } from '../../../healtheraComponents';
import { LIVE_DASHBOARD, LIVE_REPORTS } from '../constants';
import useLocationQuery from '../../../hooks/useQuery';

const DashboardTabs = () => {
  const { changeLocationQuery, query } = useLocationQuery();

  const onTabChange = (_, tab) => {
    changeLocationQuery({
      tab,
      page: 0,
    });
  };

  return (
    <TabButtons
      height={`64px`}
      value={query.tab || LIVE_DASHBOARD}
      onChange={onTabChange}
    >
      <TabHealthera value={LIVE_DASHBOARD} disableRipple label={'Dashboard'} />
      <TabHealthera value={LIVE_REPORTS} disableRipple label={'Reports'} />
    </TabButtons>
  );
};

export default DashboardTabs;
